import styled from 'styled-components';

export const SearchIconContainer = styled.div`
  cursor: pointer;
`;

export const ClearButton = styled.button`
  line-height: 0;
  margin-right: 5px;
`;
